define('uikit/modules/loader',['require','exports','module','underscore','marionette','../mixins/component.mixin','../templates','../channel','../extra/size'],function(require, exports, module){
  var _ = require('underscore');
  var Mn = require('marionette');
  var ComponentMixin = require('../mixins/component.mixin');
  var Templates = require('../templates');
  var channel = require('../channel');
  var Size = require('../extra/size');

  var Loader = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'ui loader',

    template: Templates.UIKit['loader'],

    options: {
      active   : false,
      inline   : false,
      centered : false,
      floated  : null,
      text     : '',
      size     : ''
    },

    sizeOptionValues: _.values(Size),

    forceUpdate: { text: true },

    bindings: {
      // active : 'active',
      // text   : 'text'
    },

    updateAttributes: function() {
      this
          .addClass('active', this.getBoolOption('active'))
          .addClass('disabled', !this.getBoolOption('active'))
          .addClass('text', this.getBoolOption('text'))
          .addClass('centered', this.getBoolOption('centered'))
          .addClass('inline', this.getBoolOption('inline'))
          .addClass(this.getOption('floated') + ' floated', this.getBoolOption('floated'))
          .addClass(this.getOption('size'))
    }

  });

  channel.reply('loader', function() {
    return Loader;
  });

  module.exports = Loader;
});
